<template>
<div class="chapter">
<div class="inner_page">
<p class="Fm13"><em><a id="page_9"></a>And the King shall answer and say unto them, Verily I say unto you, Inasmuch as ye have done it unto one of the least of these my brethren, ye have done it unto me</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0006.vue?34bfe5cc